import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { EndpointResponse } from '@/types/endpoints';
import type { Integration } from '@/types/integration';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'limit' | 'query'>;

export const getIntegrations = async (
  scope: RequestScope,
  params: RequestParams | undefined,
  options: ReadRequestOptions
): Promise<EndpointResponse<Integration[]>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<Integration[]>>('/integration', {
      ...options,
      params: { limit: params?.limit || 1000, query: params?.query },
    });
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
